import { TableCell, Typography } from "@mui/material"
import { getCurrencySymbol } from "../format-utils"

export function ComparisonTradeHeaderCell({ item: variant }) {
    const currencySymbol = getCurrencySymbol(variant?.costResult?.currency || variant?.rateCardCurrency)
    return (
        <TableCell align="right">
            <Typography variant="subtitle2" noWrap>
                {variant.name} ({currencySymbol})
            </Typography>
        </TableCell>
    )
}
